var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserDirectory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50002 12.9167H6.25002C5.08705 12.9167 4.50557 12.9167 4.0324 13.0602C2.96707 13.3834 2.13339 14.217 1.81022 15.2824C1.66669 15.7555 1.66669 16.337 1.66669 17.5M12.0834 6.25C12.0834 8.32107 10.4044 10 8.33335 10C6.26229 10 4.58335 8.32107 4.58335 6.25C4.58335 4.17893 6.26229 2.5 8.33335 2.5C10.4044 2.5 12.0834 4.17893 12.0834 6.25ZM9.16669 17.5L11.7512 16.7616C11.8749 16.7262 11.9368 16.7085 11.9945 16.682C12.0458 16.6585 12.0945 16.6298 12.1399 16.5965C12.1911 16.5589 12.2366 16.5134 12.3277 16.4224L17.7084 11.0417C18.2837 10.4664 18.2837 9.53362 17.7084 8.95831C17.1331 8.38302 16.2003 8.38303 15.625 8.95833L10.2443 14.339C10.1533 14.43 10.1078 14.4756 10.0702 14.5267C10.0368 14.5722 10.0082 14.6209 9.98465 14.6722C9.95815 14.7299 9.94046 14.7918 9.9051 14.9155L9.16669 17.5Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDirectory);
export default __webpack_public_path__ + "static/media/User-Directory.4ef2f064c0ae5955cd87c8db62f0fa70.svg";
export { ForwardRef as ReactComponent };